<template>
  <div
    class="min-h-screen bg-gradient-to-br from-orange-50 via-white to-orange-100 flex items-stretch"
  >
    <div class="hidden lg:flex lg:w-1/2 p-10 items-center justify-center">
      <div class="max-w-lg">
        <img
          :src="logoUrl"
          alt="Respina"
          class="h-10 w-auto mb-6"
        />
        <h1 class="text-4xl font-extrabold text-gray-900 leading-tight">
          Welcome back
        </h1>
        <p class="mt-3 text-gray-600 text-lg">
          Sign in to manage your flight board searches.
        </p>
        <img
          :src="chamedoonUrl"
          alt=""
          class="mt-10 h-40 w-auto object-contain"
        />
      </div>
    </div>

    <div class="w-full lg:w-1/2 flex items-center justify-center p-6">
      <div class="w-full max-w-sm">
        <router-view />
      </div>
    </div>
  </div>
</template>

<script>
import logoUrl from "@/assets/respina/logo.png";
import chamedoonUrl from "@/assets/respina/chamedoon.png";

export default {
  data() {
    return { logoUrl, chamedoonUrl };
  },
};
</script>
